module.exports = __webpack_public_path__ + "public/img/avatarUser.e6c84eb2.png";